if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();
        if (!this.hasAttribute('available')) return;

        // Safely check for the template to prevent errors if it's missing
        const template = this.querySelector('template');
        if (template) {
          this.errorHtml = template.content.firstElementChild.cloneNode(true);
        }
        
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.getAttribute('data-variant-id'));
      }

      fetchAvailability(variantId) {
        let rootUrl = this.getAttribute('data-root-url');
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch(() => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.getAttribute('data-variant-id'));
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.innerHTML = '';
          this.removeAttribute('available');
          this.setAttribute('hidden', '');
        }
      }

      renderError() {
        this.innerHTML = '';
        if (this.errorHtml) this.appendChild(this.errorHtml);
        const btn = this.querySelector('button');
        if (btn) btn.addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        // Target BOTH tag name (Shopify default) AND class name (custom code)
        const drawer = document.querySelector('pickup-availability-drawer') || document.querySelector('.pickup-availability-drawer');
        if (drawer) drawer.remove();
        
        // Check for the preview container (either class or tag)
        const hasPreview = sectionInnerHTML.querySelector('.pickup-availability-preview') || sectionInnerHTML.querySelector('pickup-availability-preview');
        
        if (!hasPreview) {
          this.innerHTML = '';
          this.removeAttribute('available');
          this.setAttribute('hidden', '');
          return;
        }

        // Replace the current HTML with the newly fetched HTML
        const newAvailability = sectionInnerHTML.querySelector('pickup-availability');
        if (newAvailability) {
          this.innerHTML = newAvailability.innerHTML;
        }
        
        this.removeAttribute('hidden');
        this.setAttribute('available', '');

        // Grab the drawer from the fetched HTML and append it to the body
        const newDrawer = sectionInnerHTML.querySelector('pickup-availability-drawer') || sectionInnerHTML.querySelector('.pickup-availability-drawer');
        if (newDrawer) {
          document.body.appendChild(newDrawer);
        }

        // Add a tiny timeout to guarantee the DOM has processed the innerHTML change
        setTimeout(() => {
          const button = this.querySelector('.pickup-availability-button') || this.querySelector('button');
          
          if (button) {
            button.addEventListener('click', (evt) => {
              evt.preventDefault();
              
              const targetDrawer = document.querySelector('pickup-availability-drawer') || document.querySelector('.pickup-availability-drawer');
              
              if (targetDrawer) {
                // Method 1: Shopify native custom element function
                if (typeof targetDrawer.show === 'function') {
                  targetDrawer.show(evt.target);
                } 
                // Method 2: Fallback for standard CSS/HTML popups
                else {
                  targetDrawer.setAttribute('open', '');
                  targetDrawer.classList.add('active', 'is-open', 'is-active'); // Covers most custom theme classes
                }
              } else {
                console.error("Pickup drawer element not found in DOM");
              }
            });
          }
        }, 50);
      }
    }
  );
}

// Your custom toggle behavior for the Click & Collect details
document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.pickup-toggle');
  if (!toggle) return;

  e.preventDefault();

  const wrapper = toggle.closest('pickup-availability');
  if (!wrapper) return;

  const content = wrapper.querySelector('.pickup-content');
  if (!content) return;

  content.classList.toggle('active');

  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', !expanded);
});